import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  FileType,
  filterFileListForFileType,
  getAcceptedFileExtensions,
} from '@app/image-viewer/models/file-type';
import { ImageUploadRequest } from '@app/shared/models/image-upload-request';

@Component({
  selector: 'app-document-upload',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./document-upload.component.scss'],
})
export class DocumentUploadComponent implements OnInit {
  @Input()
  acceptedFileTypes: FileType[] = [];
  @Input()
  showHeader: boolean = true;

  @Output()
  documentSelectedEvent = new EventEmitter<ImageUploadRequest[]>();
  @Output()
  selectionClearedEvent = new EventEmitter();
  images: ImageUploadRequest[] = [];

  public uploader: FileUploader = new FileUploader({
    allowedMimeType: ['application/pdf', 'image/tiff', 'image/jpeg'],
    url: '',
  });
  doneLoading: boolean;

  @ViewChild('fileInput')
  fileInput: ElementRef;

  constructor() {}

  ngOnInit(): void {}

  setSelectedFile(event: FileList) {
    const filteredFiles = filterFileListForFileType(
      event,
      this.acceptedFileTypes,
    );
    if (filteredFiles.length > 0) {
      this.loadFiles(filteredFiles);
    }
  }

  loadFiles(files?: File[]) {
    this.doneLoading = false;

    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      for (const file of fileArray) {
        const reader = new FileReader();
        reader.onload = () => {
          const urlData = reader.result as any;
          const request: ImageUploadRequest = {
            imageBytes: urlData.split(',')[1] as ArrayBuffer,
            imageType: file.type,
            name: file.name,
          };
          this.images = [...this.images, request];
          this.uploadDoc();
        };

        reader.onerror = () => {
          console.error(reader.error);
        };

        reader.readAsDataURL(file);
      }
    }
    this.doneLoading = true;
  }

  uploadDoc() {
    this.documentSelectedEvent.emit(this.images);
  }

  clearSelection() {
    this.images = [];
  }

  openFileDialog() {
    this.fileInput.nativeElement.click();
  }

  getHasFiles() {
    return this.images.length > 0;
  }

  getFileNames() {
    return this.images.map((image) => image.name);
  }

  removeFile(index: number) {
    this.images.splice(index, 1);
  }

  reorderItems(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.images, event.previousIndex, event.currentIndex);
  }

  getHasMultipleFiles() {
    return this.images.length > 1;
  }

  getAcceptedExtensions() {
    return getAcceptedFileExtensions(this.acceptedFileTypes);
  }
}
